import type { ArticlePreview } from "@brookbush/types";

import Image from "next/image";
import Link from "next/link";

import SectionContainer from "~/components/SectionContainer";

interface LandingPageArticlesProps {
	articles: ArticlePreview[];
}

const LandingPageArticles = ({ articles }: LandingPageArticlesProps) => {
	if (!articles?.length) return null;

	return (
		<SectionContainer className="flex flex-col items-center bg-gradient-to-br from-sky-900/50 to-slate-900 py-12">
			<h2 className="text-center font-bold text-2xl text-white sm:text-4xl lg:text-4xl">
				Related Articles
			</h2>

			<div className="relative grid gap-8 py-10 md:px-8 xl:grid-cols-2">
				{articles.map((article) => (
					<div
						key={article._id}
						className="flex flex-col gap-4 rounded-xl bg-white shadow-lg transition-all sm:flex-row sm:gap-6 dark:bg-slate-700"
					>
						<Link
							prefetch={false}
							className="relative h-56 w-full shrink-0 overflow-hidden rounded-t-xl border hover:brightness-95 sm:h-[17rem] sm:w-60 sm:rounded-l-xl sm:rounded-tr-none"
							href={`/articles/${article.slug}`}
						>
							<Image
								src={
									article.thumbnail?.url ||
									"/logos/brookbush-institute-logo-icon.png"
								}
								alt={article.title}
								fill
								className={
									article.thumbnail
										? "object-cover"
										: "object-contain p-4 brightness-95 dark:invert dark:saturate-0"
								}
							/>
						</Link>

						<div className="flex w-full justify-between gap-2 px-4 py-6">
							<div className="group flex flex-col justify-between gap-5">
								<div>
									<Link href={`/articles/${article.slug}`}>
										<h2 className="line-clamp-2 font-semibold text-xl hover:underline sm:text-2xl">
											{article.title}
										</h2>{" "}
									</Link>

									<p className="mt-1 line-clamp-4">{article.description}</p>
								</div>

								<div className="flex gap-2">
									<Link
										href={`/articles/${article.slug}`}
										target="_blank"
										className="flex h-min max-w-max shrink-0 items-center justify-center gap-2 rounded-full bg-sky-500 px-3 py-1.5 text-base text-white shadow-md hover:brightness-95 dark:bg-sky-600 dark:text-slate-50"
									>
										Read More
									</Link>
								</div>
							</div>
						</div>
					</div>
				))}
			</div>
		</SectionContainer>
	);
};

export default LandingPageArticles;
